import { render } from "./BuildingSegmentsTable.vue?vue&type=template&id=3cf17941"
import script from "./BuildingSegmentsTable.vue?vue&type=script&lang=js"
export * from "./BuildingSegmentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__